import React from "react";
import moment from "moment";
import axios from "axios";
import * as apiEndPoints from "../shared/apiPaths";
import Notification from "../shared/notification";
import Error from "../components/error/error"
import analytics from "../shared/analytics"

const documents = props => {
  let cardContent = <p>There are no documents to display.</p>;

  const DownloadButtonClickHandler = (documentId, extension, fileDownloadName) => {
    var url = window.ENV.API_ROOT + apiEndPoints.DOCUMENT + "/" + documentId;

    const config = {
      headers: { Authorization: props.token.token, Accept: 'image/png' },
      responseType: 'blob'
    };

    analytics.trackEvent(
      {
        "key": "Open.Document",
        "segmentation": {
          "extension": extension
        }
      }
    );

    axios
      .get(url, config)
      .then(response => {
        const doc = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = doc;
        link.setAttribute('download', fileDownloadName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        Notification.showNotification("danger", "Unable to open document");
      });
  }

  if (props.documents.error) cardContent = Error(props.documents.error);
  if (props.documents.documents.length > 0) {
    cardContent = props.documents.documents.map(document => {
      if (document.extension === ".xfd") return <div />;

      const documentDate = moment(document.lastModified).format("DD/MM/YYYY");

      return (
        <mosaic-alert key={document.id} token={props.token}>
          <mosaic-alert-text>
            <p>
              <strong>{document.description}</strong>
              <br />
              {documentDate}
            </p>
          </mosaic-alert-text>
          <mosaic-alert-actions>
            <mosaic-button onClick={(id, extension, description) => DownloadButtonClickHandler(document.id, document.extension, document.description)}>
              Download
            </mosaic-button>
          </mosaic-alert-actions>
        </mosaic-alert>
      );
    });
  }

  return (
    <mosaic-col xl="6">
      <mosaic-card id={props.cardName} fixed-height full-height>
        <mosaic-card-header title="Documents" />
        <mosaic-card-body>
          <div>{cardContent}</div>
        </mosaic-card-body>
      </mosaic-card>
    </mosaic-col>
  );
};

export default documents;
